module.exports = __webpack_public_path__ + "img/depmap_svg_V219.e507c8c1.svg";